import { inject, Injectable } from '@angular/core';
import { combineLatest, map } from 'rxjs';
import { EventTrackingService } from '../../../shared/event-tracking/event-tracking.service';
import { FloatingPanelService } from '../../shared/misc-services/floating-panel.service';
import { AddHighlightFeedbackPanelComponent } from '../views/add-highlight-feeback-panel/add-highlight-feedback-panel.component';
import { EditHighlightFeedbackPanelComponent } from '../views/edit-highlight-feedback-panel/edit-highlight-feedback-panel.component';
import { HighlightFeedbackListPanelComponent } from '../views/highlight-feedback-list-panel/highlight-feedback-list-panel.component';

@Injectable()
export class HighlightFeedbackPanelService {
  private readonly floatingPanelService = inject(FloatingPanelService);
  private readonly eventTrackingService = inject(EventTrackingService);

  private panels = [
    HighlightFeedbackListPanelComponent,
    AddHighlightFeedbackPanelComponent,
    EditHighlightFeedbackPanelComponent,
  ];

  showHighlightList(source: 'reopen' | 'toggle') {
    this.floatingPanelService.open(HighlightFeedbackListPanelComponent);
    if (source !== 'reopen') {
      this.eventTrackingService.track({
        id: 'open_feedback_list',
        bucket: 'quality_feedback',
        type: 'object',
        sub_type: 'highlight',
        source,
      });
    }
  }

  showAddHighlight() {
    this.floatingPanelService.open(AddHighlightFeedbackPanelComponent);
  }

  showEditHighlight() {
    this.floatingPanelService.open(EditHighlightFeedbackPanelComponent);
  }

  arePanelsOpen$() {
    const arePanelsOpen$ = this.panels.map((panel) =>
      this.floatingPanelService.isOpen$(panel),
    );
    return combineLatest(arePanelsOpen$).pipe(
      map((isOpenList) => isOpenList.some((isOpen) => isOpen)),
    );
  }

  close() {
    this.floatingPanelService.close();
  }
}
